<div class="d-flex flex-wrap gap-4">
  <ng-content></ng-content>
</div>
<div *ngIf="error && errorMessage" class="error-text d-block">
  {{ errorMessage }}
</div>
